var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,24H2V3C2,1.346,3.346,0,5,0h14c1.654,0,3,1.346,3,3V24Zm-18-2H20V3c0-.551-.449-1-1-1H5c-.551,0-1,.449-1,1V22ZM18,5h-6v2h6v-2Zm0,6h-6v2h6v-2Zm0,6h-6v2h6v-2ZM10,4H6v4h4V4Zm0,6H6v4h4v-4Zm0,6H6v4h4v-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulation);
export default __webpack_public_path__ + "static/media/regulation.b7f40af3c7f5462143c3fd8b031ff6c5.svg";
export { ForwardRef as ReactComponent };